import { useCookies } from "react-cookie";

const useIsConnected = (): boolean => {
  const [cookies] = useCookies(["apiKey"]);

  return cookies.apiKey ?? false;
};

export default useIsConnected;
